module.exports = __webpack_public_path__ + "static/media/sales-history.3c392b6f.svg";